import React, { useState, useContext, useEffect, useRef } from "react";
import { GlobalContext } from "./../Context";
import "./CountrySelection.scss";

export const CountrySelection = () => {
  const { currentCountry, countriesInfo } = useContext(GlobalContext);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isOpen]);

  const onSelected = (selectedCountry) => {
    const link = `${location.origin}/${selectedCountry.fieldGroupMachineName}`;
    const expiryTime = 60 * 60 * 24 * 365 * 5;
    document.cookie = `selectedCountry=${link}; path=/; max-age=${expiryTime}; secure=true`;
    location.href = `${link}/ubicaciones`;
  };

  return (
    <div className="language-switcher-dropdown" ref={dropdownRef}>
      <div className="dropdown-menu">
        <button
          type="button"
          name="laguage-switcher-btn"
          className="header-laguage-switcher-btn header-laguage-switcher-btn--es-pa"
          data-once="languageSwitcher"
          onClick={toggleDropdown}
        >
          {currentCountry && (
            <>
              <span className="button-switcher-flag">
                <img
                  src={`/themes/custom/bac_theme/images/flags/${currentCountry.fieldGroupMachineName.split('-')[1]}.svg`}
                  alt={`Bandera ${currentCountry.entityLabel}`}
                />
              </span>
              <span className="country-id">{currentCountry.fieldGroupMachineName.split('-')[1]}</span>
            </>
          )}
        </button>
        {isOpen && (
          <ul className="links open country-list">
            {currentCountry &&
              countriesInfo &&
              countriesInfo.groupQuery.entities
                .filter((country) => country.entityPublished && country.fieldGroupMachineName !== "es")
                .map((country) => (
                  <li
                    key={country.id}
                    hrefLang={country.fieldGroupMachineName}
                    className={`country-card ${country.fieldGroupMachineName}`}
                  >
                    <div className="country-data">
                      <img
                        className="country-item-image"
                        src={`/themes/custom/bac_theme/images/flags/${country.fieldGroupMachineName.split('-')[1]}.svg`}
                        alt={`Bandera ${country.label}`}
                      />
                      <button
                        href={`/${country.fieldGroupMachineName}/ubicaciones`}
                        className={`language-link ${
                          currentCountry.fieldGroupMachineName ===
                            country.fieldGroupMachineName && "country-selected"
                        }`}
                        hrefLang={country.fieldGroupMachineName}
                        onClick={() => {
                          onSelected(country);
                        }}
                      >
                        {country.label}
                      </button>
                    </div>
                  </li>
                ))}
          </ul>
        )}
      </div>
    </div>
  );
};
